import React from 'react';

class PortalSettingCheckbox extends React.Component {

    constructor(props) {

        super(props);
        this.onChecked = this.onChecked.bind(this);
    }

    onChecked(e) {

        this.props.onChange(this.props.settingKey, e.target.checked);
    }

    render() {

        return (
            <div className="form-check">
                <label className="form-check-label">
                    <input type="checkbox" className="form-check-input" checked={this.props.checked} onChange={this.onChecked} />
                    {this.props.label}
                </label>
                {this.props.help && (
                    <small className="form-text text-muted">{this.props.help}</small>
                )}
            </div>
        );
    }
}

export default PortalSettingCheckbox;
